import Swal from "sweetalert2";
const weightValidation = e => {
  if (!e.target.value) return;
  if (typeof parseFloat(e.target.value) !== "number") return;

  const value = parseFloat(e.target.value);

  let message = "";

  if (value < 0.05) {
    message =
      "<p style='font-size: 20px'>وزن مرسوله نمی‌تواند کمتر از <strong class='fs-3'>50</strong> گرم (0.050 کیلوگرم) باشد</p>";
  }

  if (value > 30) {
    message =
      "<p style='font-size: 20px'>مرسوله با وزن بیشتر از 30 کیلوگرم در یک بسته توسط اداره پست حمل نمیشود<br>مرسولات با وزن بیشتر از 30 کیلوگرم تا 100 کیلو گرم توسط سرویس های ماهکس و چاپار و ... حمل میگردد </p>";
  }

  if (message)
    Swal.fire({
      icon: "error",
      title: "اخطار",
      html: message,
      confirmButtonText: '<i class="fa fa-thumbs-up"></i> فهمیدم',
      confirmButtonColor: "red",
      iconColor: "red",
    });
};

export default weightValidation;
